// The route table, typed. src/routes.json is the source of truth; this module
// only widens it once so both App.tsx and the notes index can read it.
//
// The JSON import carries a literal type with exactly the keys it happens to
// have today, which cannot be indexed by an arbitrary pathname. Widening it
// here keeps the lookup honest and still fails the build if an entry stops
// matching RouteMeta.

import routesJson from "./routes.json";
import type { RouteMeta } from "./types";

export const ROUTES: Readonly<Record<string, RouteMeta>> = routesJson;

/** Published notes, newest first. A note is any route whose component is "Note". */
export const NOTES: readonly (RouteMeta & { readonly path: string })[] = Object.freeze(
  Object.entries(ROUTES)
    .filter(([, meta]) => meta.component === "Note")
    .map(([path, meta]) => ({ ...meta, path }))
    .sort((a, b) => (b.published ?? "").localeCompare(a.published ?? ""))
);
